import { parseResponse } from  '../../../helpers/api'
import client from '../../../client'
import _ from 'lodash';

export default {
    async getAll () {
        return client.common.get(`/clients/all`).then((response) => {
            return parseResponse(response)
        })
    },
    async createClient (clientData) {
        return client.common.post(`/clients/create`, {
                title: _.get(clientData, 'title'),
                reportEmail: _.get(clientData, 'reportEmail'),
                reportSendMode: _.get(clientData, 'reportSendMode'),
                periodExecution: _.get(clientData, 'periodExecution'),
                contractNumber: _.get(clientData, 'contractNumber'),
                contractDate: _.get(clientData, 'contractDate'),
                commonTitle: _.get(clientData, 'commonTitle'),
                useCommonTitleInReports: _.get(clientData, 'useCommonTitleInReports'),
                defaultSampleTarget: _.get(clientData, 'defaultSampleTarget')
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async updateClient (clientData) {
        return client.common.post(`/clients/update`, {
            id: _.get(clientData, 'id'),
            title: _.get(clientData, 'title'),
            reportEmail: _.get(clientData, 'reportEmail'),
            reportSendMode: _.get(clientData, 'reportSendMode'),
            periodExecution: _.get(clientData, 'periodExecution'),
            contractNumber: _.get(clientData, 'contractNumber'),
            contractDate: _.get(clientData, 'contractDate'),
            commonTitle: _.get(clientData, 'commonTitle'),
            useCommonTitleInReports: _.get(clientData, 'useCommonTitleInReports'),
            defaultSampleTarget: _.get(clientData, 'defaultSampleTarget')
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async deleteClient (clientId) {
        return client.common.post(`/clients/delete`, {
            id: clientId
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async createClientSpecialist (clientSpecialistData) {
        return client.common.post(`/clients/create-specialist`, {
            clientId: _.get(clientSpecialistData, 'clientId'),
            name: _.get(clientSpecialistData, 'name'),
            position: _.get(clientSpecialistData, 'position'),
            phone: _.get(clientSpecialistData, 'phone'),
            email: _.get(clientSpecialistData, 'email'),
            comment: _.get(clientSpecialistData, 'comment'),
            ex: _.get(clientSpecialistData, 'ex')
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async updateClientSpecialist (clientSpecialistData) {
        return client.common.post(`/clients/update-specialist`, {
            id: _.get(clientSpecialistData, 'id'),
            name: _.get(clientSpecialistData, 'name'),
            position: _.get(clientSpecialistData, 'position'),
            phone: _.get(clientSpecialistData, 'phone'),
            email: _.get(clientSpecialistData, 'email'),
            comment: _.get(clientSpecialistData, 'comment'),
            ex: _.get(clientSpecialistData, 'ex')
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async deleteClientSpecialist (clientSpecialistId) {
        return client.common.post(`/clients/delete-specialist`, {
            id: clientSpecialistId
        }).then((response) => {
            return parseResponse(response)
        })
    },
}